export const currencyCodes = {
  980: "UAH", // Ukrainian Hryvnia
  840: "USD", // US Dollar
  978: "EUR", // Euro
  985: "PLN", // Polish Zloty
  826: "GBP", // Pound Sterling
  392: "JPY", // Japanese Yen
  756: "CHF", // Swiss Franc
  156: "CNY", // Chinese Yuan
  203: "CZK", // Czech Koruna
  348: "HUF", // Hungarian Forint
  946: "RON", // Romanian Leu
  975: "BGN", // Bulgarian Lev
  949: "TRY", // Turkish Lira
  376: "ILS", // Israeli New Shekel
  124: "CAD", // Canadian Dollar
  36: "AUD", // Australian Dollar
};

export const getCurrencyName = (code) => {
  return currencyCodes[Number(code)] || code;
};
